import React from 'react';
import { Accordion, Segment } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import rightSVG from '@plone/volto/icons/right-key.svg';
import downSVG from '@plone/volto/icons/down-key.svg';
import AnimateHeight from 'react-animate-height';
import Options from './Panes/Options';

const messages = defineMessages({
  configuration: {
    id: 'configuration',
    defaultMessage: 'Configuration',
  },
});

const PlayerConfig = (props) => {
  const {
    currentActiveFieldset,
    handleCurrentActiveFieldset,
    videoSourceExist,
  } = props;
  const intl = useIntl();

  return (
    <div key="configuration" id="blockform-fieldset-configuration">
      <Accordion.Title
        active={currentActiveFieldset === 0}
        index={0}
        onClick={handleCurrentActiveFieldset}
      >
        <>{intl.formatMessage(messages.configuration)}</>
        {currentActiveFieldset === 0 ? (
          <Icon name={downSVG} size="20px" />
        ) : (
          <Icon name={rightSVG} size="20px" />
        )}
      </Accordion.Title>
      <Accordion.Content active={currentActiveFieldset === 0}>
        <AnimateHeight
          animateOpacity
          duration={500}
          height={currentActiveFieldset === 0 ? 'auto' : 0}
        >
          {videoSourceExist() && (
            <Segment className="attached">
              <Options {...props} />
            </Segment>
          )}
        </AnimateHeight>
      </Accordion.Content>
    </div>
  );
};

export default PlayerConfig;
